/* eslint-disable no-irregular-whitespace */
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import React from "react";

import { Box, Header, Text } from "~/components/blocks";

const Section = styled("section")(({ theme }) =>
  css({
    marginTop: theme.space.xl,
    fontSize: theme.fontSizes.s,
    "& > p + ul": {
      marginTop: theme.space.m,
    },
    "& > ul li + li": {
      marginTop: theme.space.s,
    },
  }),
);

export const Terms = () => {
  const theme = useTheme();

  return (
    <Box padding={theme.space.s}>
      <Header as="h2">処方箋情報事前送信サービス利用規約</Header>

      <Section>
        <Header as="h3">第1条（適用）</Header>
        <ul>
          <li>
            1.
            本規約は、株式会社メドレー（以下「当社」といいます。）が調剤薬局を利用する患者としてのユーザーに対して提供する処方箋情報事前送信サービス（以下「本サービス」といいます。）について、ユーザーがこれを利用する際の権利義務や条件を定めるものです。
          </li>
          <li>
            2.
            本規約は、ユーザーと当社との間で、ユーザーによる本サービスの利用に関わる一切の関係に適用されます。
          </li>
          <li>
            3.
            本規約の内容と、本規約外における本サービスの説明・ヘルプ・投稿・ガイドライン等（以下、「個別規定」といいます。）とが異なる場合は、個別規定が優先して適用されるものとします。
          </li>
          <li>
            4.
            ユーザーが未成年である場合には、親権者等の法定代理人の同意（本規約への同意を含みます。）を得て本サービスを利用してください。また、本規約に同意した時点で未成年であったユーザーが、成年に達した後に本サービスを利用した場合、未成年であった間の利用行為を追認したものとみなします。
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">第2条（定義）</Header>
        <ul>
          <li>
            1.
            「本サービス」とは、当社が企画・運営する処方箋情報事前送信サービスをいいます。
          </li>
          <li>
            2.
            「ユーザー」とは、本サービスを利用して登録調剤薬局による医薬品の調剤や服薬指導等を受ける個人をいいます。
          </li>
          <li>
            3.
            「本サイト等」とは、当社が、本サービスを提供するためのウェブサイトまたはアプリをいいます。
          </li>
          <li>
            4.
            「本契約」とは、当社がユーザーに対し、本サービスを提供することを約することをいいます。
          </li>
          <li>
            5.
            「登録調剤薬局」とは、、本サービスを利用・導入して、ユーザーに対して調剤業務、服薬指導、処方薬等の提供をする調剤薬局やその他法人であり、調剤・服薬指導等の業務に従事する者をいいます。
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">第3条（ユーザー）</Header>
        <ul>
          <li>
            1.
            ユーザーは、本サービスの利用に際し、本規約の定めに従うことを承諾したものとみなします。
          </li>
          <li>
            2. ユーザーは、自らの意思によって本サービスを利用するものとします。
          </li>
          <li>
            3.
            ユーザーは、本サービスの利用にあたり、本サイト等の定めるところに従い情報の入力を行う必要があり、当該情報入力の完了及び処方箋情報事前送信機能の利用をもって本契約が成立するものとします。なお、本サービスの利用はその都度のユーザー情報の入力及び処方箋情報事前送信機能の利用をもって完了するものとし、本サービスには登録手続や退会手続は発生しないものとします。
          </li>
          <li>
            4.
            ユーザーは、本サービスにおいて入力した情報の内容について一切の責任を負います。当社は、各ユーザーが入力した情報については、当社の定める「処方箋情報事前送信サービスにおける個人情報の取扱いについて」（以下「プライバシーポリシー」といいます。）に従って取り扱うものとします。
          </li>
          <li>
            5.
            ユーザーは、自らの責任と費用において、本サービスの利用に必要な環境（ハードウェア、ソフトウェア、インターネット接続回線、セキュリティーの確保等）を整備するものとします。当社は、ユーザーのデータの情報セキュリティを確保するために、本サービスに関するインフラストラクチャ、ネットワーク、アプリケーション及びデータ等を対象とした情報セキュリティ対策を必要に応じて行うこととします。
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">第4条（本サービスの利用）</Header>
        <ul>
          <li>
            1.ユーザーは、本サービスの利用にあたり、登録調剤薬局に処方箋情報等（処方箋画像を含む）を事前に送信します。
          </li>
          <li>
            2.本サービス上で登録調剤薬局への処方箋情報の事前送信が完了した場合、当社は、ご入力いただいたユーザーの電話番号宛てに申込み完了のSMSを送信します。
          </li>
          <li>
            3.ユーザーが、申込み完了後に当該申込みをキャンセルする場合、前項に定める申込み完了SMSに記載されたキャンセル用URLにアクセスして手続きを行うか、または処方箋情報の事前送信をした登録調剤薬局へ直接連絡してキャンセルをしなければならないものとします。ユーザーは、本項所定のキャンセル手続を行わずに申込み先の登録調剤薬局で処方薬の受取りを行わなかった場合、本サービスの爾後の利用が停止または制限される場合があることを予め承諾するものとします。
          </li>
          <li>
            4.ユーザーは、その選択により、登録調剤薬局に事前送信した処方箋情報に基づく医薬品の調剤が完了した際の通知をSMS経由で受け取ることができるものとします。
          </li>
          <li>
            5.
            本サービスは、ユーザーの登録調剤薬局における待機時間の負担を軽減し、医薬品の調剤が完了した際に登録調剤薬局がユーザーに対するSMS通知を行うことを可能にするためのサービスであり、当社は、ユーザーが申し込んだ医薬品の調剤が希望通りに行われることその他の医療行為の適切な完了を保証するものではありません。当社は、当社の故意または重過失がない限り、登録調剤薬局が行う医療行為についていかなる責任も負わないものとします。
          </li>
          <li>
            6.
            ユーザーは、本サービスを用いて調剤依頼を行った医薬品を登録調剤薬局において受領するものとし、受領時期の遅延その他の医薬品を受領しなかったことによりユーザーに生じた損害について、当社は、当社の故意または重過失がない限り、いかなる責任を負わないものとします。
          </li>
          <li>
            7.
            医薬品の調剤業務等に関連して生じた問い合わせ、苦情、請求、紛争等については、ユーザー及び登録調剤薬局との間で解決するものとします。当社は、これらの紛争等については、一切責任を負うことなく、また、その解決に関与する義務を負わないものとします。
          </li>
          <li>
            8.ユーザーは、事前送信した処方箋情報に基づく医薬品の受領後、登録調剤薬局からSMS経由で当該医薬品の利用に関するフォローアップが行われる場合があることに承諾するものとし、フォローアップの実施または不実施によりユーザーに何らかの損害が生じた場合においても、当社は、当社の故意または重過失がない限り、いかなる責任を負わないものとします。
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">第5条（禁止事項・損害賠償）</Header>
        <ul>
          <li>
            1. ユーザーは、以下の各行為を行ってはならないものとします。
            <ul>
              <li>
                (1) 当社、および登録調剤薬局に対し虚偽の情報を提供する行為
              </li>
              <li>
                (2)
                他人の調剤・服薬指導等を不正に受ける目的で本サービスを利用する行為
              </li>
              <li>
                (3) 複数の薬局から同一の処方箋に基づく処方薬を得ようとする行為
              </li>
              <li>
                (4)
                本サービスの利用に関し、自らまたは第三者のために不正な利益を得ようとする行為
              </li>
              <li>
                (5)
                他人の知的財産権、プライバシーに関する権利、その他の権利または利益を侵害する行為
              </li>
              <li>
                (6)
                コンピューター・ウイルスその他の有害なコンピューター・プログラムを含む情報を送信する行為
              </li>
              <li>(7) 個人や団体を誹謗中傷する行為</li>
              <li>
                (8)
                本サービスで得た情報を本サービスの利用目的の範囲を超えて第三者に譲渡する行為または営利目的で譲渡する行為
              </li>
              <li>(9) 公序良俗に反する行為</li>
              <li>(10) 法令に反する一切の行為</li>
              <li>
                (11)
                各登録調剤薬局への本サービスの利用の申込みを繰り返す等、各登録調剤薬局の営業を妨害する方法で本サービスを利用する行為
              </li>
              <li>(12) 本サービスの運営を妨げる行為</li>
              <li>
                (13)
                その他本サービスの提供を継続することが困難であると当社が判断する一切の行為
              </li>
            </ul>
          </li>
          <li>
            2.
            ユーザーが本規約の各条項に違反し、当社または第三者に対して損害を与えた場合は、ユーザーは当社または第三者に対し損害賠償義務を負うものとします。
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">第6条（情報の変更・削除、本契約の解除等）</Header>
        <p>
          当社は、ユーザーが本規約に違反する行為をし、もしくはその行為をする恐れがある場合（ユーザーの登録情報が架空・虚偽または誤りだった場合を含みますが、これに限られません。）、ユーザーによる本サービスの利用が不適切であると当社が判断する場合、ユーザーによる本サービスの利用により本サービスの運営に支障が生じると当社が判断する場合、当該ユーザーに何ら事前の通知をすることなく以下の措置を講じることができるものとします。なお、当社はユーザーに対し、下記の措置を講じる理由について説明する義務を負いません。
        </p>
        <ul>
          <li>
            (1)
            ユーザーが本サービスにおいて入力した情報の全部または一部についての変更または削除
          </li>
          <li>
            (2)
            本契約の解除およびそれに伴う本サービス利用の停止、または、本サービスのユーザーに対する利用禁止措置
          </li>
          <li>(3) その他当社が必要と認める措置</li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">第7条（サービス内容の変更）</Header>
        <p>
          当社は、ユーザーの事前の承諾なしに本サービスの内容を変更することができるものとします。
        </p>
      </Section>

      <Section>
        <Header as="h3">第8条（サービス停止・終了等）</Header>
        <p>
          当社は、以下のいずれかに該当する事由によりユーザーへの事前の通知および承諾を要することなく、本サービスを停止または終了することができます。
        </p>
        <ul>
          <li>
            (1)
            本サービス運営のためのシステムの保守、更新等を定期的または臨時に行う場合
          </li>
          <li>
            (2)
            ウィルス被害、火災、停電、天災地変などの不可抗力により、本サービスの提供が困難な場合
          </li>
          <li>
            (3)
            第三者の故意または過失による行為によって発生した本システムの不具合について対策を講じる必要がある場合
          </li>
          <li>
            (4) 法令等の改正、成立により本サービスの運営が困難となった場合
          </li>
          <li>
            (5) その他、当社が本サービスの提供の停止・終了が必要と判断した場合
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">第9条（免責）</Header>
        <ul>
          <li>
            1.
            当社は、ユーザー等が本サービスに入力する情報等に関し、内容の正確性、有用性、完全性等について何らの保証をしないものとします。
          </li>
          <li>
            2.
            当社は、本サービスの利用に関し、以下のことを保証しないものとします。
            <ul>
              <li>(1) 本サービスが中断しないこと</li>
              <li>(2) 本サービスにエラーが生じないこと</li>
              <li>(3) 本サービスの利用に関し通信回線等の障害がないこと</li>
              <li>
                (4)
                本サイト等上のコンテンツに関する盗用、毀損または改ざんがないこと
              </li>
              <li>
                (5)
                本サイト等に対する不正アクセス・ハッキング等のサイバー攻撃がないこと
              </li>
            </ul>
          </li>
          <li>
            3.
            当社は、ユーザーの本サービスへの登録および本サービスの利用から生じる一切の損害に関して、責任を負わないものとします。
          </li>
          <li>
            4.
            当社は、当社による本サービスの内容の変更、本サービスの提供の停止または終了、本サービスの利用不能、本サービスの利用によるデータの消失または機器の故障若しくは損傷、その他本サービスに関連してユーザーが被った損害につき、一切責任を負わないものとします
          </li>
          <li>
            5.
            前3条の規定により、ユーザーの情報が変更・削除された場合、本契約が解除された場合、本サービス内容が変更された場合、または本サービスが停止・終了した場合においても、ユーザーと登録調剤薬局との間で成立する調剤業務等に関する契約の内容に影響を及ぼすものではありません。
          </li>
          <li>
            6.
            当社は、ユーザーによる本サービスの利用により、ユーザーの疾病・疾患が治癒し、診療等が終了することを保証するものではなく、また、登録調剤薬局がユーザーへの調剤業務や服薬指導等を開始・継続することを保証するものではありません。
          </li>
          <li>
            7.
            当社が本サービスに関してユーザーに対して損害賠償責任を負うべき場合でも、ユーザーは当社に損害発生についての故意または重過失がある場合に限り損害賠償を請求することができるものとします。この場合において、ユーザーは、当社の責任は直接かつ通常の損害に限られることに同意するものとします。
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">第10条（暴力団等排除条項）</Header>
        <ul>
          <li>
            1.
            ユーザーは、現在、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力団等、その他これらに準ずる者(以下、これらを「暴力団員等」といいます。)に該当しないことを表明し、かつ将来にわたっても該当しないことを確約するものとします。
          </li>
          <li>
            2.
            ユーザーは、自らまたは第三者を利用して次の各号の一にでも該当する行為を行わないことを確約するものとします。
            <ul>
              <li>(1) 暴力的な要求行為</li>
              <li>(2) 法的な責任を超えた不当な要求行為</li>
              <li>
                (3) 取引に関して、脅迫的な言動をし、または暴力を用いる行為
              </li>
              <li>
                (4)
                風説を流布し、偽計を用いまたは威力を用いて、当社、他の利用者、その他第三者の信用を毀損し、または、当社、他の利用者、その他第三者の業務を妨害する行為
              </li>
              <li>(5) その他前各号に準ずる行為</li>
            </ul>
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">第11条（提供情報の利用）</Header>
        <ul>
          <li>
            1.
            本サービスにおける個人情報の取り扱いについては、プライバシーポリシーに従うものとします。ユーザーは、本サービスを利用する場合には、プライバシーポリシーの各規定に従うことを承諾したものとみなします。
          </li>
          <li>
            2.
            当社は、本サービスを提供する上でユーザーにとって必要な情報を、ユーザーに対し、SMSでの通知等によって連絡をすることができるものとします。
          </li>
          <li>
            3.
            当社は、当社の定めるプライバシーポリシーで定義される個人情報を含まない限りにおいて、登録情報または本サービスの利用状況についての情報を、あらゆるものに二次利用することができるものとします。これらの情報に関わる知的財産権は当社が保有するものとします。
          </li>
          <li>
            4.
            ユーザーは、本サービスの利用に伴う発生する各種ログ情報を含むユーザーデータを、本サービスの提供する機能を通じてのみ閲覧・利用できるものとし、当社はログその他のユーザーデータの提供依頼等に対応する義務を負わないものとします。
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">第12条（規約の変更）</Header>
        <p>
          当社は、ユーザーの承諾を得ることなく、本規約を随時変更することができ、本サイト等上に表示された時点より効力を生じるものとします。
        </p>
      </Section>

      <Section>
        <Header as="h3">第13条（準拠法および管轄裁判所）</Header>
        <p>
          本サービスおよび本規約を含む本契約の準拠法は日本法とします。本サービスおよび本規約を含む本契約に関して生じる一切の紛争については、東京地方裁判所または東京簡易裁判所を第
          1 審の専属的合意管轄裁判所とします。
        </p>
      </Section>

      <Box textAlign="right" marginTop={theme.space.l}>
        <Text as="p" size="s">
          2021年10月19日制定
          <br />
          株式会社メドレー
          <br />
          代表取締役社長　瀧口　浩平
        </Text>
      </Box>
    </Box>
  );
};
